/**
 * Invite-request API calls.
 *
 * Public: submit a request (no auth)
 * Admin: list, approve, deny
 */

import { api } from './client.js';

// ── public ──

export function submitInviteRequest(payload) {
  return api.post('/api/invite-requests', payload, { skipAuth: true });
}

// ── admin ──

export function listInviteRequests() {
  return api.get('/api/admin/invite-requests');
}

export function getInviteRequest(id) {
  return api.get(`/api/admin/invite-requests/${id}`);
}

export function approveInviteRequest(id, payload = {}) {
  return api.post(`/api/admin/invite-requests/${id}/approve`, payload);
}

export function denyInviteRequest(id, payload = {}) {
  return api.post(`/api/admin/invite-requests/${id}/deny`, payload);
}
